import { AuthStrategyType } from '../../tenants/types';
import { LoginStrategy } from './LoginStrategy';
import { UrlTokenStrategy } from './UrlTokenStrategy';
import { AuthStrategy, AuthStrategyOptions } from './types';

/** Un constructor por tipo: si se agrega un `AuthStrategyType` sin su estrategia, falla al compilar. */
const STRATEGY_BUILDERS: Record<AuthStrategyType, (options: AuthStrategyOptions) => AuthStrategy> = {
    [AuthStrategyType.Login]: options => {
        if (!options.loginPath || !options.landingPath) {
            throw new Error(
                '[auth] LoginStrategy requiere `session.loginRoute` y `session.landingRoute` en el config del tenant.'
            );
        }
        return new LoginStrategy({ ...options, loginPath: options.loginPath, landingPath: options.landingPath });
    },
    [AuthStrategyType.UrlToken]: options => new UrlTokenStrategy(options)
};

export const authStrategyFactory = (type: AuthStrategyType, options: AuthStrategyOptions): AuthStrategy =>
    STRATEGY_BUILDERS[type](options);
